import tableBase from "../common/TableBase"


import { fetchTrendData } from "../common/FetchFilterData";
const url = "https://app.vantetider.se/spa/1.1/rest/prediction/result";


class predictionTable extends tableBase {
    constructor() {
        const template = document.createElement("div");
        template.style.position = 'relative'
        super(template);


        //Create main component, table
        //Event listener. When filterSubmit is triggered, update the table
        document.addEventListener("predictionFilterSubmit", async (e) => {
            this.showSpinner(template);
            var params = e.detail;
            if (params.values.regionIds.toString() === "-1") {
                delete params.values.regionIds;
            }
            if (params.values.serviceId.toString() === "-1") {
                delete params.values.serviceId;
            }
            try {
                const res = await fetchTrendData(url, params.values, 'series');

                var categories = res.xNames;
                var series = [];
                res.series.forEach(s => {

                    const region = s.data.shift().y;

                    series.push({
                        name: region,
                        data: s.data.map((data, i) => {
                            return data.y;
                        }),
                        systemChange: s.data.map((data) => data?.systemChange == true )
                    })
                });
                
                
                this.createTable(categories, series, true, false);
                this.addSummary("Tabell som visar beräknad väntetid för valt vårdutbud och region.");
                this.addCaption("*Det begränsade antalet kan innebära att prognoserna är osäkra.", "tableTitle");
            } catch (error) {
                this.hideSpinner();
                this.errorNoData();
                console.error(error);
            }
        })
    }
}

if (!customElements.get("prediction-table")) {
    tableBase.define("prediction-table", predictionTable)
}
